import { StatoEntita } from '../tipologiche/stato-entita';
import { DatiCatastaliBase } from './dati-catastali-base';
import { DatiCatastaliTerreniExtra } from './dati-catastali-terreni-extra';
import { DatiCatastaliUrbanoExtra } from './dati-catastali-urbano-extra';
import { DatiDenuncia } from './dati-denuncia';
import { IstanzaAssegnazione } from './istanza-assegnazione';
import { IstanzaVendita } from './istanza-vendita';
import { Ubicazione } from './ubicazione';

export class BenePignoratoImmobile {
  id: string;
  tipoCatasto: StatoEntita;
  descrizione: string;
  ubicazione: Ubicazione;
  valore: any;
  valoreIpoteca : any;
  ipoteca: boolean;
  nudaProprieta: boolean;
  datiCatastaliBase: DatiCatastaliBase;
  datiCatastaliUrbanoExtra: DatiCatastaliUrbanoExtra;
  datiCatastaliTerreniExtra: DatiCatastaliTerreniExtra;
  datiDenuncia: DatiDenuncia;
  istanzaVendita: IstanzaVendita;
  istanzaAssegnazione: IstanzaAssegnazione;
  note: string;
}
